import React from 'react'

function AmountPickerPercent({handleClickOnMaxAmout}) {
  return (
    <div className="flex gap-2">
          <p
            onClick={() => {
              handleClickOnMaxAmout(25);
            }}
            className="text-sm font-medium  hover:cursor-pointer bg-[#D8E9FE] dark:bg-dark-secondary px-1 rounded shadow-sm"
          >
            25%
          </p>
          <p
            onClick={() => {
              handleClickOnMaxAmout(50);
            }}
            className="text-sm font-medium hover:cursor-pointer bg-[#D8E9FE] dark:bg-dark-secondary px-1 rounded shadow-sm"
           
          >
            50%
          </p>
          <p
            onClick={() => {
              handleClickOnMaxAmout(100);
            }}
            className="text-sm font-medium  hover:cursor-pointer bg-[#D8E9FE] dark:bg-dark-secondary px-1 rounded shadow-sm"
           
          >
            Max
          </p>
        </div>
  )
}

export default AmountPickerPercent